import React from 'react'
import ContactBody from '../components/ContactBody'

export default function Contact() {
  return (
    <div className='Contact'>
      <ContactBody/>
    </div>
  )
}
